import api from "../../../api/axios";

// Thin call-wrappers around /api/companies/{id}/. Phase 9 reads via
// CompanyDetailSerializer and writes via CompanyWriteSerializer
// (partial=True). No new axios instance; existing interceptors handle
// auth headers and 401 refresh.

export const fetchCompany = (companyId) =>
  api.get(`/companies/${companyId}/`).then((res) => res.data);

export const patchCompanyContact = (companyId, partial) =>
  api
    .patch(`/companies/${companyId}/`, partial)
    .then((res) => res.data);
